import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=5ad59df8&scoped=true"
import script from "./Shell.vue?vue&type=script&lang=js"
export * from "./Shell.vue?vue&type=script&lang=js"
import style0 from "./Shell.vue?vue&type=style&index=0&id=5ad59df8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad59df8",
  null
  
)

export default component.exports